const MAX_TIMER_DELAY = 2147483647

let expiryTimer = null
let endingSession = false

export function getTokenExpiration(token) {
  if (!token || typeof token !== 'string') {
    return null
  }

  const jwt = token.replace(/^Bearer\s+/i, '')
  const parts = jwt.split('.')
  if (parts.length !== 3) {
    return null
  }

  try {
    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const remainder = payload.length % 4
    if (remainder) {
      payload += new Array(5 - remainder).join('=')
    }

    const decoded = JSON.parse(atob(payload))
    return typeof decoded.exp === 'number' && isFinite(decoded.exp)
      ? decoded.exp * 1000
      : null
  } catch (error) {
    return null
  }
}

export function isTokenExpired(token, now = Date.now()) {
  const expiresAt = getTokenExpiration(token)
  return expiresAt !== null && expiresAt <= now
}

export function expireSession(store) {
  if (endingSession || !store.state.token) {
    return
  }

  endingSession = true
  store.dispatch('LOG_OUT')
  window.location.replace('/login?redirect=session_ended')
}

function scheduleExpiryCheck(store) {
  if (expiryTimer) {
    window.clearTimeout(expiryTimer)
    expiryTimer = null
  }

  const expiresAt = getTokenExpiration(store.state.token)
  if (expiresAt === null) {
    return
  }

  const remaining = expiresAt - Date.now()
  if (remaining <= 0) {
    expireSession(store)
    return
  }

  // Browser timers cannot safely exceed ~24.8 days. The session lasts 30
  // days, so long waits are split and recalculated until the real expiry.
  expiryTimer = window.setTimeout(
    () => scheduleExpiryCheck(store),
    Math.min(remaining, MAX_TIMER_DELAY)
  )
}

export function watchSessionExpiry(store) {
  const unsubscribe = store.subscribe(mutation => {
    if (mutation.type === 'SET_TOKEN' || mutation.type === 'REMOVE_TOKEN') {
      endingSession = false
      scheduleExpiryCheck(store)
    }
  })

  const checkAfterInactivity = () => scheduleExpiryCheck(store)
  const checkWhenVisible = () => {
    if (!document.hidden) {
      scheduleExpiryCheck(store)
    }
  }

  window.addEventListener('focus', checkAfterInactivity)
  document.addEventListener('visibilitychange', checkWhenVisible)
  scheduleExpiryCheck(store)

  return () => {
    unsubscribe()
    window.removeEventListener('focus', checkAfterInactivity)
    document.removeEventListener('visibilitychange', checkWhenVisible)
    if (expiryTimer) {
      window.clearTimeout(expiryTimer)
      expiryTimer = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/sessionExpiry.js